import React, { createContext, useContext, useMemo } from "react";

interface AssessmentDashboardContextState {
  program: string;
}

const AssessmentDashboardContext = createContext<
  AssessmentDashboardContextState | undefined
>(undefined);

export function useAssessmentDashboardContext() {
  const context = useContext(AssessmentDashboardContext);
  if (context === undefined) {
    throw new Error(
      "AssessmentDashboardContext must be used within a AssessmentDashboardContextProvider",
    );
  }
  return context;
}

interface Props {
  program: string;
  children: React.ReactNode;
}

const AssessmentDashboardContextProvider = ({ program, children }: Props) => {
  const value = useMemo(
    () => ({
      program,
    }),
    [program],
  );

  return (
    <AssessmentDashboardContext.Provider value={value}>
      {children}
    </AssessmentDashboardContext.Provider>
  );
};

export default AssessmentDashboardContextProvider;
